import React from "react";

interface Props {
  type: 'SQUARE' | 'LINE' | 'CIRCLE'
}

export const Loader = (props: Props) => {
  const { type } = props;
  
  switch (type) {
    case 'SQUARE':
      return <div style={{ width: 50, height: 50, borderRadius: 4, backgroundColor: '#eaeced' }}/>
    case 'LINE':
      return <div style={{ width: 150, height: 10, borderRadius: 4, backgroundColor: '#eaeced' }}/>
    case 'CIRCLE':
      return <div style={{ width: 15, height: 15, borderRadius: '50%', backgroundColor: '#eaeced' }}/>
    default:
      return <div></div>
  }

};